import { render, staticRenderFns } from "./pkgDistribut.vue?vue&type=template&id=57edb83c&"
import script from "./pkgDistribut.vue?vue&type=script&lang=js&"
export * from "./pkgDistribut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports